<template>
  <FilterGroup
    :is-collapsible="isCollapsible"
    :label="filter.name"
    is-boolean
    height="h-5"
  >
    <Button
      v-if="!isMobileOrTablet && showNewDesktopPlpQuickFilters"
      class="flex items-center justify-between"
      no-padding
      ignore-capitalisation
      :is-active="modelValue"
      type="muted"
      :data-test-id="`toggle-filter-${filter.slug}`"
      role="checkbox"
      :aria-checked="modelValue"
      tabindex="0"
      @click="toggle"
      @keydown.space.prevent="toggle"
      @keydown.enter.prevent="toggle"
    >
      <span>{{ translateLabel(filter.name) }}</span>
      <Toggle
        :model-value="modelValue"
        is-muted
        :aria-label="translateLabel(filter.name)"
      />
    </Button>

    <Toggle
      v-else
      :model-value="modelValue"
      :aria-label="translateLabel(filter.name)"
      class="mb-0"
      @update:model-value="toggle"
    />
  </FilterGroup>
</template>

<script lang="ts">
import type { ProductFilter } from '@scayle/storefront-nuxt'

import FilterGroup from '~/components/filters/FilterGroup.vue'
import Toggle from '~/components/ui/toggle/Toggle.vue'
import { useDeviceType } from '~/composables/useDeviceType'

export default defineComponent({
  name: 'BooleanFilter',
  components: { Toggle, FilterGroup },
  props: {
    modelValue: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    filter: {
      type: Object as PropType<ProductFilter>,
      required: true,
    },
    filterValues: {
      type: Array as PropType<any[]>,
      required: true,
    },
    isCollapsible: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  emits: ['update:modelValue', 'apply'],
  setup(props, { emit }) {
    const i18n = useI18n()
    const { showNewDesktopPlpQuickFilters } = useExperiments()
    const { isMobileOrTablet } = useDeviceType()

    const translateLabel = (label: string) => {
      const translationKey = `filter.${label.toLowerCase()}`
      const translatedText = i18n.t(translationKey)

      return translatedText === translationKey ? label : translatedText
    }

    const toggle = () => {
      emit('update:modelValue', !props.modelValue)
    }

    return {
      showNewDesktopPlpQuickFilters,
      isMobileOrTablet,
      translateLabel,
      toggle,
    }
  },
})
</script>
